import { h, defineComponent, SetupContext, VNodeChildren } from 'vue';
import { VNodeData } from 'vue/types/vnode.d';

export const Box = defineComponent({
  name: 'Box',
  setup(_, context: SetupContext) {
    return function render() {
      return h('div', { class: 'box is-relative' }, context.slots.default?.());
    };
  },
});

export function box(contents: VNodeChildren, attrs: VNodeData = {}) {
  return h(Box, attrs, contents);
}
